export default __webpack_public_path__ + "static/media/4.1280ffa7.svg";